@if (rooms.length > 1) {
  <div class="plan-selector">
    <label for="visits-plan">Plan:</label>
    <select id="visits-plan" [ngModel]="pid" (ngModelChange)="selectPlan($event)">
      @for (room of rooms; track room.pid) {
        <option [ngValue]="room.pid">{{ room.name }}</option>
      }
    </select>
  </div>
}

@if (!courseVisit) {
  <div class="no-course-container">

    <h1>Zur Zeit kein Kurs!</h1>

    <div class="past-course-picker-inline">

      <label class="picker-label">
        Kurse in der Vergangenheit auswählen:
      </label>

      <input
        type="date"
        [(ngModel)]="pastDate"
        class="picker-input-date"
        [max]="today">

      <input
        type="time"
        [(ngModel)]="pastTime"
        class="picker-input-time">

      <button
        (click)="goToPastCourse()"
        class="picker-button">
        Go!
      </button>

    </div>

  </div>
}

@if (courseVisit) {

  <div id="content">

    <div class="grid-item">

      <h1>{{ courseVisit.name }}</h1>

      <h2>
        {{ courseVisit.date | date: 'dd.MM.yyyy' }},
        {{ courseVisit.begin }} -
        {{ courseVisit.end }}
      </h2>

      <button
        class="button-add"
        (click)="add()">
        Hinzufügen
      </button>

    </div>

    <div class="grid-item"></div>

    <div class="grid-item-full">

      @if (loading) {

        <div>
          <mat-spinner class="center"></mat-spinner>
        </div>

      } @else {

        <table mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="Name">

            <th mat-header-cell *matHeaderCellDef>
              Name
            </th>

            <td mat-cell *matCellDef="let element">
              {{ element | name }}
            </td>

          </ng-container>

          <ng-container matColumnDef="Visited">

            <th mat-header-cell *matHeaderCellDef>
              Anwesend
            </th>

            <td mat-cell *matCellDef="let element">

              <input
                type="checkbox"
                [checked]="element.visited > 0"
                (change)="visit(element)">

            </td>

          </ng-container>

          <ng-container matColumnDef="Remove">

            <th mat-header-cell *matHeaderCellDef>
              Entfernen
            </th>

            <td mat-cell *matCellDef="let element">

              <button
                mat-icon-button
                class="button-remove"
                (click)="remove(element)"
                matTooltip="Schüler aus Kurs entfernen">

                <mat-icon>delete</mat-icon>

              </button>

            </td>

          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="['Name', 'Visited', 'Remove']">
          </tr>

          <tr
            mat-row
            *matRowDef="
              let row;
              columns: ['Name', 'Visited', 'Remove']
            ">
          </tr>

        </table>

        @if (trialSource.data.length > 0) {

          <h3 class="trial-title">Probestunde</h3>

          <table mat-table [dataSource]="trialSource" class="trial-table">

            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let element">{{ element | name }}</td>
            </ng-container>

            <ng-container matColumnDef="Visited">
              <th mat-header-cell *matHeaderCellDef>Anwesend</th>
              <td mat-cell *matCellDef="let element">
                <input
                  type="checkbox"
                  [checked]="true"
                  (change)="visit(element)"
                  matTooltip="Haken entfernen löscht die Probestunde">
              </td>
            </ng-container>

            <ng-container matColumnDef="Enroll">
              <th mat-header-cell *matHeaderCellDef>Kurs</th>
              <td mat-cell *matCellDef="let element">
                <button
                  type="button"
                  class="button-enroll"
                  (click)="enrollTrial(element)"
                  matTooltip="Ab der ersten Probestunde in den Kurs eintragen">
                  Eintragen
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['Name', 'Visited', 'Enroll']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['Name', 'Visited', 'Enroll']"></tr>

          </table>
        }

      }

    </div>

    <div class="grid-item"></div>
    <div class="grid-item"></div>

  </div>
}


@if (showStudentSelection) {

  <div id="student-selection-overlay">

    <div id="student-selection-container">

    <h2>Teilnehmer hinzufügen</h2>

    <input
      type="text"
      class="student-search-input"
      [(ngModel)]="studentSearch"
      placeholder="Schüler suchen oder neuen Schüler eingeben...">

    @if (filteredStudents.length > 0) {

      <div class="student-selection-list">

        @for (student of filteredStudents; track student.sid) {

          <div class="student-selection-item">

            <span class="student-selection-name">
              {{ student.firstname }}
              {{ student.lastname }}
            </span>

            <button
              type="button"
              class="student-selection-trial"
              (click)="addTrial(student)">
              Probestunde
            </button>

            <button
              type="button"
              class="student-selection-enroll"
              (click)="addToCourse(student)">
              Zum Kurs hinzufügen
            </button>

          </div>

        }

      </div>

    } @else if (!studentSearch.trim()) {

      <p class="no-students">
        Es sind keine weiteren Schüler für diesen Kurs verfügbar.
      </p>

    } @else {

      <p class="no-students">
        Kein bestehender Schüler gefunden.
      </p>

    }

    @if (studentSearch.trim()) {

      <button
        type="button"
        class="student-selection-new"
        (click)="addNewStudent()">

        „{{ studentSearch }}“ als neuen Schüler anlegen (Probestunde)

      </button>

    }

      <button
        type="button"
        class="button-close"
        (click)="closeStudentSelection()">
        Close
      </button>

    </div>

  </div>

}

<li-student-edit
  [student]="newStudent"
  (closing)="newStudentSaved($event)">
</li-student-edit>